import styled from 'styled-components';

export const StyledText = styled.div<{ font: string }>`
  font: ${(props) => props.font};

  color: ${(props) => props.color};
`;
